import { VARIABLE_CATALOG } from 'citadel-shared/variables.js'

export function registerVariableBlot(Quill) {
  if (Quill.imports['formats/variable']) return

  const Embed = Quill.import('blots/embed')

  class VariableBlot extends Embed {
    static create(value) {
      const node = super.create()
      node.setAttribute('class', 'variable-tag')
      node.innerText = value.label
      node.dataset.id = value.key
      return node
    }

    static value(node) {
      const text = node.innerText
      const match = text.match(/\{\{(.*?)\}\}/)
      const extractedText = match ? match[1] : text
      return {
        key: extractedText,
        label: VARIABLE_CATALOG[extractedText]?.label || extractedText
      }
    }
  }

  VariableBlot.blotName = 'variable'
  VariableBlot.tagName = 'span'
  VariableBlot.className = 'variable-tag'

  Quill.register(VariableBlot)
}
